import { render, staticRenderFns } from "./work222.vue?vue&type=template&id=a252c694&scoped=true&"
import script from "./work222.vue?vue&type=script&lang=js&"
export * from "./work222.vue?vue&type=script&lang=js&"
import style0 from "./work222.vue?vue&type=style&index=0&id=a252c694&lang=scss&scoped=true&"
import style1 from "./work222.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a252c694",
  null
  
)

export default component.exports